import React from "react";
import "./styles.css";
import bg from './ImagenesBannerCFDI/bannercfdi.jpg';
import logo from './ImagenesBannerCFDI/logocfdi.png';
export default function BannerCFDI(props) {
    

    return (
        <>
            <div className="contenedorGeneralBannerCFDI">
                <div className="contenedorPrincipalBannerCFDI">
                <img src={bg}/>
                    <div className="contenedorTextoBannerCFDI">
                        <img src={logo}/>
                    </div>
                </div>
            </div>
        </>
    );
}
